import { RangeValue } from 'rc-picker/lib/interface';
import React from 'react';
import { Dayjs } from 'dayjs';
import { DatePicker } from 'antd';
import styled from 'styled-components';

type Props = {
    value?: RangeValue<Dayjs>;
    onChange: (value: RangeValue<Dayjs>) => void;
};

const RedeemRangerPicker = ({ value, onChange }: Props) => {
    return (
        <Container>
            <DateDisplay>
                <div>From: </div>
                <div>{value?.[0] ? value?.[0]?.format('MM-DD-YYYY') : '--'}</div>
                <div>to </div>
                <div>{value?.[1] ? value?.[1]?.format('MM-DD-YYYY') : '--'}</div>
            </DateDisplay>
            <DatePicker.RangePicker value={value} onChange={onChange} format={'MM-DD-YYYY'} className='redeem-ranger-picker' />
        </Container>
    );
};

export default RedeemRangerPicker;

const Container = styled.div`
    position: relative;
    display: flex;
    height: 56px;
    padding: 0 8px;
    justify-content: center;
    align-items: center;
    gap: 16px;

    border-radius: 5px;
    border: 1px solid #86909c;
    background: #fff;
    width: fit-content;
    min-width: 325px;
    .redeem-ranger-picker {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }
`;

const DateDisplay = styled.div`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 8px;
    z-index: 1;
    flex: 1;
    display: flex;
    align-self: stretch;
    gap: 16px;
    align-items: center;
    color: #505050;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
`;
